import React from "react";
import SVG from "react-inlinesvg";

import iconArrowRightBlue from "../../../../img/icons/arrow_right_blue.svg";
import { useAppDispatch } from "../../reducers";
import { Dispatchers } from "../dispatchers";

import styles from "./ConfiguratorPanelTrigger.module.scss";

const footer = document.querySelector<HTMLElement>(".site-footer");
const PDPHero = document.querySelector<HTMLElement>(".pdp-hero");

export const showFinanceBlock = (): void => {
    if (footer) {
        footer.classList.remove("u-unset-position");
    }
    if (PDPHero) {
        PDPHero.classList.remove("u-increase-z-index");
    }
};
const hideFinanceBlock = (): void => {
    if (footer) {
        footer.classList.add("u-unset-position");
    }
    if (PDPHero) {
        PDPHero.classList.add("u-increase-z-index");
    }
};

export const disableMainConfiguratorScrolling = (): void => {
    const container = document.querySelector<HTMLElement>(
        ".pdp-hero .configurator",
    );
    if (container) {
        container.classList.add("overflow-hidden");
    }
};

interface IProps {
    prefixNameCapped: string;
    onOpenPanel: () => void;
    children: React.ReactNode;
}

export const ConfiguratorPanelTrigger = (props: IProps) => {
    const dispatch = useAppDispatch();
    return (
        <button
            className={styles.button}
            onClick={() => {
                props.onOpenPanel();
                hideFinanceBlock();
                const dispatchers = new Dispatchers(dispatch);
                dispatchers.setPanelTriggerState(true);
            }}
        >
            <h6>{props.prefixNameCapped}</h6>
            <span>{props.children}</span>
            <SVG aria-hidden="true" src={iconArrowRightBlue} />
        </button>
    );
};
